__turbopack_context__.v({
  "afterGrid": "fullscreen-calendar-module__C-B9dG__afterGrid",
  "band": "fullscreen-calendar-module__C-B9dG__band",
  "bandClickable": "fullscreen-calendar-module__C-B9dG__bandClickable",
  "bandContLeft": "fullscreen-calendar-module__C-B9dG__bandContLeft",
  "bandContRight": "fullscreen-calendar-module__C-B9dG__bandContRight",
  "bandLane": "fullscreen-calendar-module__C-B9dG__bandLane",
  "bandMore": "fullscreen-calendar-module__C-B9dG__bandMore",
  "bandNeutral": "fullscreen-calendar-module__C-B9dG__bandNeutral",
  "bandSpacer": "fullscreen-calendar-module__C-B9dG__bandSpacer",
  "day": "fullscreen-calendar-module__C-B9dG__day",
  "dayHead": "fullscreen-calendar-module__C-B9dG__dayHead",
  "dayLastColumn": "fullscreen-calendar-module__C-B9dG__dayLastColumn",
  "dayLastRow": "fullscreen-calendar-module__C-B9dG__dayLastRow",
  "dayMobile": "fullscreen-calendar-module__C-B9dG__dayMobile",
  "dayMonthTag": "fullscreen-calendar-module__C-B9dG__dayMonthTag",
  "dayNum": "fullscreen-calendar-module__C-B9dG__dayNum",
  "dayNumToday": "fullscreen-calendar-module__C-B9dG__dayNumToday",
  "dayOutside": "fullscreen-calendar-module__C-B9dG__dayOutside",
  "daySelected": "fullscreen-calendar-module__C-B9dG__daySelected",
  "dayWeekend": "fullscreen-calendar-module__C-B9dG__dayWeekend",
  "daysDesktop": "fullscreen-calendar-module__C-B9dG__daysDesktop",
  "daysMobile": "fullscreen-calendar-module__C-B9dG__daysMobile",
  "dot": "fullscreen-calendar-module__C-B9dG__dot",
  "dots": "fullscreen-calendar-module__C-B9dG__dots",
  "eventAvatar": "fullscreen-calendar-module__C-B9dG__eventAvatar",
  "eventCard": "fullscreen-calendar-module__C-B9dG__eventCard",
  "eventCardNext": "fullscreen-calendar-module__C-B9dG__eventCardNext",
  "eventDot": "fullscreen-calendar-module__C-B9dG__eventDot",
  "eventDotHued": "fullscreen-calendar-module__C-B9dG__eventDotHued",
  "eventMeta": "fullscreen-calendar-module__C-B9dG__eventMeta",
  "eventMore": "fullscreen-calendar-module__C-B9dG__eventMore",
  "eventName": "fullscreen-calendar-module__C-B9dG__eventName",
  "eventTop": "fullscreen-calendar-module__C-B9dG__eventTop",
  "gridColumn": "fullscreen-calendar-module__C-B9dG__gridColumn",
  "nav": "fullscreen-calendar-module__C-B9dG__nav",
  "navBtn": "fullscreen-calendar-module__C-B9dG__navBtn",
  "navToday": "fullscreen-calendar-module__C-B9dG__navToday",
  "railColumn": "fullscreen-calendar-module__C-B9dG__railColumn",
  "root": "fullscreen-calendar-module__C-B9dG__root",
  "split": "fullscreen-calendar-module__C-B9dG__split",
  "toolbar": "fullscreen-calendar-module__C-B9dG__toolbar",
  "toolbarMonth": "fullscreen-calendar-module__C-B9dG__toolbarMonth",
  "toolbarSub": "fullscreen-calendar-module__C-B9dG__toolbarSub",
  "toolbarTitleBlock": "fullscreen-calendar-module__C-B9dG__toolbarTitleBlock",
  "weekDay": "fullscreen-calendar-module__C-B9dG__weekDay",
  "weekHead": "fullscreen-calendar-module__C-B9dG__weekHead",
  "weekRow": "fullscreen-calendar-module__C-B9dG__weekRow",
});
